import { cameraSettingZod, localeZod, themeSettingZod } from "@connected-repo/zod-schemas/enums.zod";
import { garmentNounZod } from "@connected-repo/zod-schemas/retailer_settings.zod";
import { zTimezone } from "@connected-repo/zod-schemas/zod_utils";
import { env } from "@frontend/configs/env.config";
import { createAuthClient } from "better-auth/client";
import { adminClient, inferAdditionalFields, usernameClient } from "better-auth/client/plugins";

// Empty VITE_API_URL = same-origin reverse-proxy deploy. Fall back to the
// current page origin so better-auth issues cookies against the visible domain.
const authBaseUrl =
  env.VITE_API_URL ||
  (typeof window !== "undefined" ? window.location.origin : undefined);

export const authClient = createAuthClient({
  baseURL: authBaseUrl,
   plugins: [
    inferAdditionalFields({
      user: {
          timezone: {
            defaultValue: "Etc/UTC",
            input: true,
            required: true,
            type: "string",
            validator: {
              input: zTimezone,
              output: zTimezone
            }
          },
          themeSetting: {
            type: "string",
            required: true,
            defaultValue: "system",
            input: true,
            validator: {
              input: themeSettingZod,
              output: themeSettingZod
            }
          },
          activeTeamAppId: {
            type: "string",
            required: false,
            defaultValue: null,
            input: false,
          },
          locale: {
            type: "string",
            required: false,
            defaultValue: "en",
            input: true,
            validator: {
              input: localeZod,
              output: localeZod
            }
          },
          cameraSetting: {
            type: "string",
            required: false,
            defaultValue: "back",
            input: true,
            validator: {
              input: cameraSettingZod,
              output: cameraSettingZod
            }
          },
          // The garment type picked last on the counter; the studio's default
          // for every customer (null = the retailer's default).
          garmentNoun: {
            type: "string",
            required: false,
            defaultValue: null,
            input: true,
            validator: {
              input: garmentNounZod.nullable(),
              output: garmentNounZod.nullable()
            }
          }
      }
    }),
    usernameClient(),
    adminClient(),
  ]
});